
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 18.6a9.43 9.43 0 00-5.172-8.397c-.096 6.92-5.706 12.53-12.626 12.626a9.43 9.43 0 008.397 5.172c1.692 0 3.337-.451 4.783-1.307l4.577 1.266-1.266-4.577A9.367 9.367 0 0028 18.6z","fill":"#FB8FB0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.202.059c5.594 0 10.144 4.55 10.144 10.143 0 5.594-4.55 10.144-10.144 10.144-1.823 0-3.597-.485-5.156-1.406l-4.95 1.369 1.37-4.95a10.112 10.112 0 01-1.407-5.157C.059 4.61 4.609.06 10.202.06zM6.277 6.457c.929-1.324 2.111-2.066 3.936-2.066 1.942 0 4.014 1.504 4.014 3.487 0 1.637-1.109 2.272-1.946 2.752-.51.292-.92.526-.92.894v.131c0 .301-.245.545-.548.545H9.156a.547.547 0 01-.55-.545v-.222c0-1.37 1.022-1.937 1.824-2.383l.059-.033c.694-.386 1.12-.65 1.12-1.161 0-.677-.87-1.127-1.573-1.127-.895 0-1.32.41-1.893 1.123a.552.552 0 01-.76.094l-.987-.743a.543.543 0 01-.119-.746zM8.4 14.441c0-.867.71-1.572 1.584-1.572a1.58 1.58 0 011.585 1.572 1.58 1.58 0 01-1.585 1.573A1.58 1.58 0 018.4 14.44z","fill":"#E84B7A"}})])
          )
        }
      }
    